import { api } from "@breakout/backend/convex/_generated/api"
import type { Maybe } from "@breakout/shared/types/market"
import { convexQuery } from "@convex-dev/react-query"
import { useQuery } from "@tanstack/react-query"
import type { Address } from "viem"

interface MarketStatsArgs {
	marketAddress: Address
}

export function useMarketStats(args: Maybe<MarketStatsArgs>) {
	return useQuery({
		...convexQuery(api.indexer.public.getMarketStats, {
			marketAddress: args?.marketAddress ?? "",
		}),
		enabled: !!args,
	})
}
